import { Provider } from 'react-redux';
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import HeaderFooter from '../header-footer/HeaderFooter';
import { CommunicationSection, CsvData, FooterLink, ReduxState } from '../../types';
import { setCommonState } from '../../store/slices/common';
import { setFooterTaxo } from '../../store/slices/taxonomy';
import { getStore } from '../../store/store';

import 'pages/csr-header-footer/injectNavigation';

declare global {
  export interface Window {
    footerData: {
      csvData: CsvData[];
      communicationSection?: CommunicationSection;
      footerLinks?: FooterLink[];
      searchApi?: string;
      thumbnailApi?: string;
      tickerApi?: string;
      storeIdentifierName: string;
    };
    footerReduxData: ReduxState;
    cartCountComponent?: {
      setCartCount: (value: string | number) => void;
    };
  }
}

const store = getStore();

if (window.footerReduxData) {
  store.dispatch(setFooterTaxo(window.footerReduxData.taxonomy.footer));
  store.dispatch(setCommonState(window.footerReduxData.common));
}

hydrateRoot(
  document.getElementById('responsive-footer') as HTMLElement,
  <StrictMode>
    <Provider store={store}>
      <HeaderFooter route="footer" store={store} />
    </Provider>
  </StrictMode>,
);
